import React from 'react';
import { Trash2, X } from 'lucide-react';

interface SelectionBarProps {
  count: number;
  onDelete: () => void;
  onDone: () => void;
  disabled?: boolean;
}

export const SelectionBar: React.FC<SelectionBarProps> = ({
  count,
  onDelete,
  onDone,
  disabled,
}) => {
  return (
    <div className="sticky bottom-0 z-20 -mx-4 md:mx-0 mt-4 bg-white border-t-2 border-gray-200 p-3 flex items-center gap-2">
      <button
        type="button"
        onClick={onDone}
        className="min-h-[48px] px-3 rounded-xl bg-gray-100 text-gray-700 font-bold text-sm flex items-center gap-1"
      >
        <X size={16} />
        Done
      </button>
      <p className="flex-1 text-sm font-bold text-gray-700">
        {count} selected
      </p>
      <button
        type="button"
        onClick={onDelete}
        disabled={disabled || count === 0}
        className="min-h-[48px] px-4 rounded-xl bg-red-600 text-white font-bold text-sm flex items-center gap-2 disabled:opacity-40"
      >
        <Trash2 size={16} />
        Delete
      </button>
    </div>
  );
};
